export { Slide } from './Slide'
export { SlidesCarousel } from './SlidesCarousel'



// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/core/impl/ui/index.jsx